<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container" class="sts-trade-container">
       <!-- Contents Start { -->
       <div id="contents">

         <TradeTopNav
          :pid="route.params.id"
          />
         <!-- content start -->
         <div class="contents-area">

            <div class="trade-top-null" style="display:none;">데이터를 가져오지 못했습니다.<br>새로고침하여 주십시오.</div>
            <div class="trade-live-box">
              <!-- <div class="live-inner">
                  <div class="live-contents">
                    <iframe   v-if="isActive"   allow="autoplay;fullscreen"   id="tradeLiveBroadcast" title="실시간 방송" height="100%" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen="true" :src="`${Config.URL.apiFlextvUrl}redirects/signin?token=${token}&redirectTo=/embed/channels/${currentLiveID}/play`"></iframe>
                  </div>
              </div>
              <div class="chat-inner" >
                  <iframe v-if="isActive"      id="tradeLiveChat" title="실시간 채팅" height="100%" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen="true" :src="`${Config.URL.apiFlextvUrl}redirects/signin?token=${token}&redirectTo=/embed/v2/channels/${currentLiveID}/chat`"></iframe>
              </div> -->
              <div class="live-inner">
                <iframe allow="autoplay;fullscreen"  id="tradeLiveBroadcast" title="실시간 방송" width="100%" height="100%" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen="true" :src="`https://www.flextv.co.kr/redirects/signin?token=${token}&redirectTo=/marketings/channel-groups/popular/live`"></iframe>
              </div>

            </div>
            
         </div>
         <!-- // content end -->
         <TradeBottomNav 
            :id="route.params.id"
         />
       </div>
       <!-- } Contents End -->

     </div>
     <!-- } Container End -->

</template>

<script>
// import { useStore } from 'vuex';
import { useRoute}from 'vue-router'
//import Config from '../../../public/config.js';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import { useStore } from 'vuex';
import { onMounted, ref} from 'vue';


export default {
  components:{   
    HeaderTrade,
    TradeTopNav,
    TradeBottomNav,
  },
 
  setup(){
    const store = useStore();
    const token = ref(sessionStorage.getItem('token'));
    const route = useRoute();  
    store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'liveBroadcast'); 

    onMounted(()=>{
      //console.log("Config.URL", Config.URL)
    })

   return{
    token,
   // Config,
    route
   }
 }
}
</script>

<style>

</style>